import { FC, useEffect, useState } from 'react';
import { ButtonSelectionProps, IOption } from './ButtonSelection.props';
import { ButtonGroup, Label, RootButtonSelection } from './ButtonSelection.styles';

export const ButtonSelection: FC<ButtonSelectionProps> = ({
    listOptions,
    defaultValue,
    className,
    onChange,
    dataGtm,
    label,
}: ButtonSelectionProps) => {
    const [cacheValue, setCacheValue] = useState<any>(defaultValue);
    const handleSelection = (option: IOption) => {
        if (option.enabled) {
            setCacheValue(option.value);
            onChange(option);
        }
    };
    useEffect(() => {
        setCacheValue(defaultValue);
    }, [defaultValue]);
    return (
        <RootButtonSelection className={className} data-gtm={dataGtm}>
            <Label>{label}</Label>
            <ButtonGroup>
                {listOptions.map((item, i) => (
                    <div
                        key={`button-option-${dataGtm}-${item.label}-${i}-${item.value}`}
                        onClick={() => handleSelection(item)}
                        aria-label={`Seleccionar ${item.label}`}
                        aria-hidden="false"
                        className={`button-selection ${item.value === cacheValue && 'in-active'} ${item.enabled === false && 'disabled'}`}
                        data-gtm={`${dataGtm}-${item.value}`}
                    >
                        {item.label}
                    </div>
                ))}
            </ButtonGroup>
        </RootButtonSelection>
    );
};
